import {Box, Skeleton, Typography} from "@mui/material"
import {FC} from "react"
import {unescapeHtml} from "../../../helpers"

type Props = {
  loading: boolean
  contentText: string[]
}

const ExpertBioContent: FC<Props> = (props) => {
  const {loading, contentText} = props
  return (
    <Box
      maxHeight={"calc(100vh - 117px - 56px)"}
      sx={{
        width: "100%",
        overflowY: "auto",
        scrollBehavior: "smooth",
        paddingRight: "39px",
        "&::-webkit-scrollbar": {
          width: "4px !important",
        },
      }}
    >
      {!loading ? (
        <Typography
          sx={{
            flexGrow: 0,
            fontFamily: "Open Sans",
            fontSize: "12px",
            fontWeight: "normal",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.33,
            letterSpacing: "normal",
            textAlign: "justify",
            color: "#000",
            paddingBottom: "168px",
          }}
        >
          {contentText &&
            contentText.map((content) => (
              <div
                className="dotcom-expert-bio-textblock"
                dangerouslySetInnerHTML={{__html: unescapeHtml(content)}}
              ></div>
            ))}
        </Typography>
      ) : (
        <Box
          sx={{
            flexGrow: 0,
            fontFamily: "Open Sans",
            fontSize: "12px",
            fontWeight: "normal",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.33,
            letterSpacing: "normal",
            textAlign: "justify",
            color: "#000",
            paddingRight: "24px",
            paddingBottom: "168px",
          }}
        >
          {[1, 2, 3].map(() => (
            <Box
              sx={{
                marginBottom: "24px",
              }}
            >
              {[1, 2, 3, 4, 5, 6].map((index) => (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={16}
                  width={index === 5 ? "50%" : index === 6 ? "25%" : "100%"}
                  sx={{
                    flexGrow: 0,
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, #ffffff 100%)",
                    margin: "8px",
                  }}
                />
              ))}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default ExpertBioContent
